const SET_LOGGED_IN = 'SET_LOGGED_IN';

const SET_LOADING = 'SET_LOADING';
const SET_ERROR = 'SET_ERROR';
const SET_USER = 'SET_USER';

const SET_SUCCESS = 'SET_SUCCESS';

// const SET_SELECTED_CREDIT = 'SET_SELECTED_CREDIT';
// const SET_TOTAL_CREDITS = 'TOTAL_CREDITS';
const SET_PAYMENTS = 'SET_PAYMENTS';

// Order Filtering
const SET_SELECTED_ORDER_STATUS = 'SET_SELECTED_ORDER_STATUS';
const SET_SELECTED_ORDER_PAYMENT_METHOD = 'SET_SELECTED_ORDER_PAYMENT_METHOD';
const SET_SELECTED_ORDER_PAYMENT_STATUS = 'SET_SELECTED_ORDER_PAYMENT_STATUS';
const SET_ORDERS_FILTERED = 'SET_ORDERS_FILTERED';
const SET_CREDITS = 'SET_CREDITS';

// PRODUCTS
const SET_PRODUCTS = 'SET_PRODUCTS';
const SET_PRODUCT_COUNT = 'SET_PRODUCT_COUNT';
const LOADING_PRODUCTS = 'LOADING_PRODUCTS';

// USERS
const SET_USERS = 'SET_USERS';
const SET_USER_COUNT = 'SET_USER_COUNT';
const SET_USER_DETAILS = 'SET_USER_DETAILS';

const SET_DISTRIBUTORS = 'SET_DISTRIBUTORS';

// LOGS
const SET_SUCCESS_LOGS = 'SET_SUCCESS_LOGS';
const LOADING_LOGS = 'LOADING_LOGS';

// COUNTS
const SET_COUNTS = 'SET_COUNTS';
const LOADING_COUNTS = 'LOADING_COUNTS';
const SET_COUNT_ERROR = 'SET_COUNT_ERROR';

export {
  SET_LOGGED_IN,

  SET_LOADING,
  SET_ERROR,
  SET_USER,
  SET_SUCCESS,
  SET_PRODUCTS,
  SET_PRODUCT_COUNT,
  SET_USERS,
  SET_USER_COUNT,
  LOADING_PRODUCTS,
  SET_USER_DETAILS,
  SET_DISTRIBUTORS,
  SET_SELECTED_ORDER_STATUS,
  SET_SELECTED_ORDER_PAYMENT_METHOD,
  SET_SELECTED_ORDER_PAYMENT_STATUS,
  SET_ORDERS_FILTERED,
  SET_PAYMENTS,
  SET_CREDITS,
  SET_SUCCESS_LOGS,
  LOADING_LOGS,
  SET_COUNTS,
  LOADING_COUNTS,
  SET_COUNT_ERROR,
};
